export class HconCommonRegExp {
    /*이름 정규식 (한글+영문)*/
    static readonly user_name_regex = /^[가-힣a-zA-Z]+$/;
    static readonly USER_NAME_REGEX = /^[가-힣a-zA-Z]+$/;

    /*사용자 ID 정규식 (영문소문자, 숫자 6~20자)*/
    static readonly user_id_regex = /^[a-z0-9]{6,20}$/;
    static readonly USER_ID_REGEX = /^[a-z0-9]{6,20}$/;

    /*비밀번호 정규식*/
    /*(1)영문,숫자,특수문자 9~20자*/
    static readonly password_regex = /^(?=.*[-/:;()&@.,?!{}#%^*+=_|~$])(?=.*[A-Za-z])(?=.*\d).{9,20}$/;
    static readonly PASSWORD_REGEX = /^(?=.*[-/:;()&@.,?!{}#%^*+=_|~$])(?=.*[A-Za-z])(?=.*\d).{9,20}$/;
    /*(2)동일한 문자/숫자 3회 이상 반복 금지*/
    static readonly password_no_repeat_regex = /^(?!.*([A-Za-z0-9])\1{2,}).*$/i;
    static readonly PASSWORD_NO_REPEAT_REGEX = /^(?!.*([A-Za-z0-9])\1{2,}).*$/i;
    /*(3)연속된 문자/숫자 3회 이상 금지*/
    static readonly password_no_continuation_regex = /^(?!.*(?:012|123|234|345|456|789|890))(?!.*(?:098|987|876|765|654|543|432|321|210))(?!.*(?:abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz))(?!.*(?:zyx|yxw|xwv|wvu|vut|uts|tsr|srq|rqp|qpo|pon|onm|nml|mlk|lkj|kji|jih|ihg|hgf|gfe|fed|edc|dcb|cba)).*$/i;
    static readonly PASSWORD_NO_CONTINUATION_REGEX = /^(?!.*(?:012|123|234|345|456|789|890))(?!.*(?:098|987|876|765|654|543|432|321|210))(?!.*(?:abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz))(?!.*(?:zyx|yxw|xwv|wvu|vut|uts|tsr|srq|rqp|qpo|pon|onm|nml|mlk|lkj|kji|jih|ihg|hgf|gfe|fed|edc|dcb|cba)).*$/i;

    /*이메일 정규식*/
    static readonly EMAIL_REGEX = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

    /*전화번호 정규식*/
    /*(1-1)휴대 전화번호 정규식(하이픈포함)*/
    static readonly PHONE_REGEX = /^(?:010\d{8}|10\d{8}|01[0-9]-\d{3,4}-\d{4})$/;
    /*(1-2)휴대 전화번호 정규식(하이픈미포함)*/
    static readonly Mbl_Telno_REGEX_NO_DASH = /^0(1\d)(\d{4}|\*{4})(\d{4})$/;
    /*(2)유선 전화번호 정규식*/
    static readonly Cbl_TELNO_REGEX = /^(02|0\d{2})-(\d{3,4})-(\d{4})$/;
    /*(3)부가서비스 전화번호 정규식*/
    static readonly RPS_TELNO_REGEX = /^(15|16|18|19)\d{2}-\d{4}$/;

    // 천 단위 콤마 정규식
    static readonly amd_comma_regex = /\B(?=(\d{3})+(?!\d))/g;
}